import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "  ", -1)
const _hoisted_4 = {
  key: 2,
  style: {"width":"14px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 0,
  class: "grow"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "flex pb-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { key: "overview-details" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "strong pt-2" }, "Inkluderet i din pakke:", -1)
const _hoisted_17 = { class: "overview__coverage" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_TransitionGroup, { name: "slide-simple" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "text-left border-bottom",
        key: _ctx.productName
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", {
            class: "grow",
            innerHTML: _ctx.productNameCap
          }, null, 8, _hoisted_2),
          (_ctx.showButtons)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "strong mt-4 mr-3 icon-edit",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoProduct())),
                title: "Rediger"
              }))
            : _createCommentVNode("", true),
          _hoisted_3,
          (_ctx.showButtons)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "strong mt-4 icon-delete",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeProduct())),
                title: "Fjern"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4))
        ]),
        (_ctx.productModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.productModel.readyForBasket)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Pakke: " + _toDisplayString(_ctx.packName), 1))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "grow strong pb-4",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoProduct())),
                      title: "Rediger"
                    }, _toDisplayString(_ctx.notCalculatedTxt), 1)),
                _createElementVNode("div", {
                  innerHTML: _ctx.getMonthlyYearlyPrices(true)
                }, null, 8, _hoisted_8)
              ]),
              (_ctx.productCms.overviewShowYearlyPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", {
                      class: "flex",
                      innerHTML: _ctx.getMonthlyYearlyPrices(false)
                    }, null, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productModel.overview.highlights, (highlight, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'high' + inx
                }, [
                  _createElementVNode("div", {
                    class: "flex",
                    innerHTML: highlight
                  }, null, 8, _hoisted_12)
                ]))
              }), 128)),
              (_ctx.productModel.readyForBasket)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(['show-hide-details', { open: _ctx.showOrderDetails }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleOrderDetails && _ctx.toggleOrderDetails(...args))),
                    textContent: _toDisplayString((_ctx.showOrderDetails ? 'Skjul' : 'Vis') + ' detaljer')
                  }, null, 10, _hoisted_13))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "slide-vertical-no-delay" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productModel.overview.details, (detail, inx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'detail' + inx
                      }, [
                        _createElementVNode("div", { innerHTML: detail }, null, 8, _hoisted_15)
                      ]))
                    }), 128)),
                    _hoisted_16,
                    _createElementVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverages, (coverage, inx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: 'covOver' + inx,
                          class: "coverage"
                        }, _toDisplayString(_ctx.getCoverageName(coverage)), 1))
                      }), 128))
                    ])
                  ], 512), [
                    [_vShow, _ctx.showOrderDetails]
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  class: "strong",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoProduct())),
                  title: "Rediger"
                }, _toDisplayString(_ctx.notCalculatedTxt), 1)
              ])
            ]))
      ])), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}